/** 
  Warning: The constants in this file are not fully replicated throughout
  the project. Before making any changes, please ensure that the values 
  are consistently updated in all relevant locations to avoid discrepancies
  and potential errors.
*/

export const OrderDoctypes = {
  PRIVATE_CHANNEL: 'PSIU',
  RETAIL_CHANNEL: 'PSDT',
  FIRST_TIME_PURCHASE: 'PSNW',
  PROMOTIONAL: 'PSPO',
};
